import { render, staticRenderFns } from "./EmptyResult.vue?vue&type=template&id=6d6f4bf5&"
import script from "./EmptyResult.vue?vue&type=script&lang=js&"
export * from "./EmptyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports